// @flow

import type { Dictionary } from './types';

export const sizeRatios:Dictionary = {
  '215': 14.04,
  '225': 23.37,
  '315': 14.87,
  '325': 24.75,
  '415': 15.13,
  '425': 24.38,
  '515': 15.4,
  '525': 25.56,
  '615': 15.33,
  '625': 25.14,
  '715': 15.14,
  '725': 24.35,
  '815': 14.79,
  '825': 24.23,
  '915': 15.12,
  '925': 25.66
};

export const maxShaftSizes:Dictionary = {
  '215': 1.9375,
  '225': 1.9375,
  '315': 2.1875,
  '325': 2.1875,
  '415': 2.4375,
  '425': 2.4375,
  '515': 2.9375,
  '525': 2.9375,
  '615': 3.4375,
  '625': 3.4375,
  '715': 3.9375,
  '725': 3.9375,
  '815': 4.4375,
  '825': 4.4375,
  '915': 4.9375,
  '925': 4.9375
};

export const serviceFactors:Dictionary = {
  '< 3 hrs/day uniform to moderate shock': 1.0,
  '3 - 10 hrs/day uniformly loaded': 1.0,
  '3 - 10 hrs/day moderate shock': 1.4,
  '3 - 10 hrs/day heavy shock': 2.0,
  '> 10 hrs/day uniformly loaded': 1.4,
  '> 10 hrs/day moderate shock': 2.0,
  '> 10 hrs/day heavy shock': 2.5
};



// WEBPACK FOOTER //
// ./src/utils/vortex/mechanical-factors.js